import {VueConstructor} from "vue";
import FeaturesComponent from "~/components/features/features.vue";
import FeatureComponent from "~/components/features/feature.vue";
import {ENVIRONMENTS, FeatureIds, TEnvironments, TFeatureIds, TFeatures} from "~/interfaces/featuresInterfaces";
import Storager from "~/services/storager";
import {InstanceHelper} from "~/helpers/instanceHelper";
import {ObjectHelper} from "~/helpers/objectHelper";
import {KeyboardHelper} from "~/helpers/keyboardHelper";
import FeaturesState from "../../../../config/features.yml"

const storager = new Storager('formability:features')

interface IFeatureService {
  all: object

  install(Vue, options): void

  set(features: any): void

  save(): void

  copy(): void

  isOn(featureId: any): boolean
}

const service: IFeatureService = class FeatureService {
  private static readonly featuresState: TFeatures = FeaturesState as TFeatures
  private static readonly defaults: TFeatures = FeatureService.featuresState
  static readonly all: TFeatures = ObjectHelper.merge({}, FeatureService.defaults || {})

  static install(Vue: VueConstructor, options) {
    const savedFeatures = storager.fetch({})
    for (const feature in savedFeatures) {
      // load saved features that are also in the default list
      // weeds out features no longer available
      if (InstanceHelper.isBoolean(this.all[feature]?.[import.meta.env.MODE])) {
        this.all[feature] = savedFeatures[feature]
      }

    }
    // remove keys for other environments, not needed
    const otherEnvs = ENVIRONMENTS.filter(e => e !== import.meta.env.MODE)
    for (const id in this.all) {
      otherEnvs.forEach(e => delete this.all[id][e])
    }
    Vue.observable(this.all) // not sure why this prop was not fully reactive without this
    Vue.prototype.$feature = this // this.$feature available in all Vue components
    Vue.component("feature", FeatureComponent);

    const featuresInstance = new FeaturesComponent()
    const mount = () => {
      // mount features.vue automatically at end of body
      featuresInstance.$mount()
      document.getElementsByTagName('body')[0].appendChild(featuresInstance.$el)

      // listen for a set of keys to be pressed to toggle to experiment features modal open/closed
      $(document).on('keydown', (event) => {
        // (cmd || windows) && ctrl && (option || alt) && shift && 'd' or 'e' key is pressed
        if (KeyboardHelper.hasAllModifiers(event) && [68,69].includes(event.which)) {
          event.preventDefault();
          // @ts-ignore
          featuresInstance.toggleModal()
        }
      })
    }
    if (document.readyState === 'loading') {
      window.addEventListener("DOMContentLoaded", mount)
    } else {
      mount()
    }
  }

  static set(features: TFeatures): typeof FeatureService {
    ObjectHelper.merge(this.all, features)
    return this
  }

  static save(): typeof FeatureService {
    storager.set(this.all)
    return this
  }

  static copy(): TFeatures {
    return ObjectHelper.merge({}, this.all)
  }

  static isOn(featureId: TFeatureIds): boolean {
    if (!(ENVIRONMENTS).includes(import.meta.env.MODE as TEnvironments)) return false
    if (!FeatureIds.includes(featureId)) return false
    return this.all[featureId]?.[import.meta.env.MODE]
  }
}

export default service
